export const unboundMediaBuyerReminderTarget = () =>
  '/project-table/account-opening?mediaBuyerUnbound=1';

export const accountOpeningFilterFromSearch = (search: string) =>
  new URLSearchParams(search).get('mediaBuyerUnbound') === '1'
    ? { mediaBuyerUnbound: 1 as const }
    : {};
